import { useFeatures } from '~/composables/useFeatures';
import { useUserStore } from '~/stores/useUserStore';

export default defineNuxtPlugin(async () => {
  const { refreshFeatures } = useFeatures();
  const userStore = useUserStore();

  watch(() => userStore.user, newUser => {
    if (newUser) {
      // We are intentionally not awaiting this, because it will block rendering and other things
      refreshFeatures();
    }
  }, { immediate: true });
});